$('.js-sl-opaciti').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4.5,
  arrows: true,
  nextArrow: '<button class="additional-arr additional-next-gallery"></button>',
  prevArrow: '<button class="additional-arr additional-prev-gallery"></button>',
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3.5,
      }
    },{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.5,
      }
    },
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        slidesToShow: 2.3,
      }
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1.2,
      }
    },
  ]
})

$('.js-sl-museum').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4.5,
  arrows: true,
  nextArrow: '<button class="additional-arr additional-next-gallery"></button>',
  prevArrow: '<button class="additional-arr additional-prev-gallery"></button>',
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3.5,
      }
    },{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.5,
      }
    }, 
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        slidesToShow: 2.3,
      }
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1.2,
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/js/general/additional-sl.js